// @file Helper for post properties.
import { __ } from '@@/bits/intl'
import type { WallPostProperties } from '@@/types'

type PostPropertyToggles = Pick<
  WallPostProperties,
  'subject_enabled' | 'attachment_enabled' | 'body_enabled' | 'color_enabled' | 'location_enabled'
>
type PostPropertyToggleKey = keyof PostPropertyToggles
type PostPropertyToggleValue = PostPropertyToggles[PostPropertyToggleKey]

const POST_PROPERTY_TOGGLE_TEXT: Record<
  PostPropertyToggleKey,
  {
    fieldName: string
    toggleValues: Record<`${PostPropertyToggleValue}`, string>
  }
> = {
  subject_enabled: {
    fieldName: __('Subject'),
    toggleValues: {
      false: __('Hide'),
      true: __('Show'),
    },
  },
  attachment_enabled: {
    fieldName: __('Attachment'),
    toggleValues: {
      false: __('Hide'),
      true: __('Show'),
    },
  },
  body_enabled: {
    fieldName: __('Body'),
    toggleValues: {
      false: __('Hide'),
      true: __('Show'),
    },
  },
  color_enabled: {
    fieldName: __('Color'),
    toggleValues: {
      false: __('Hide'),
      true: __('Show'),
    },
  },
  location_enabled: {
    fieldName: __('Location'),
    toggleValues: {
      false: __('Maps only'), // Even when location is disabled, it's always shown on Maps.
      true: __('Always on'),
    },
  },
}

const SUBJECT_PLACEHOLDER_CHAR_LIMIT = 200
const SUBJECT_PLACEHOLDER_VALIDATION_MESSAGE = __(
  'Subject placeholder cannot exceed %{subjectPlaceholderCharLimit} characters',
  {
    subjectPlaceholderCharLimit: SUBJECT_PLACEHOLDER_CHAR_LIMIT,
  },
)
const BODY_PLACEHOLDER_CHAR_LIMIT = 2000
const BODY_PLACEHOLDER_VALIDATION_MESSAGE = __(
  'Body placeholder cannot exceed %{bodyPlaceholderCharLimit} characters',
  {
    bodyPlaceholderCharLimit: BODY_PLACEHOLDER_CHAR_LIMIT,
  },
)

export type { PostPropertyToggles, PostPropertyToggleKey, PostPropertyToggleValue }
export {
  POST_PROPERTY_TOGGLE_TEXT,
  SUBJECT_PLACEHOLDER_CHAR_LIMIT,
  BODY_PLACEHOLDER_CHAR_LIMIT,
  BODY_PLACEHOLDER_VALIDATION_MESSAGE,
  SUBJECT_PLACEHOLDER_VALIDATION_MESSAGE,
}
